export default "__VITE_PUBLIC_ASSET__c2a8baef__"